import { useMutation } from '@apollo/client';

import { useCurrentEventQuery } from '../../event/hooks/useCurrentEventQuery';
import { useToast } from '../../toast/Toast.context';
import {
  STAFF_LEAVE_CARPOOL_TRIP,
  StaffLeaveCarpoolTripMutation,
  StaffLeaveCarpoolTripMutationVariables,
} from '../graphql/mutation/staffLeaveCarpoolTripMutation.graphql';
import {
  CARPOOL_TRIPS,
  CarpoolTripsQueryVariables,
} from '../graphql/query/carpoolTripsQuery.graphql';

export const useStaffLeaveCarpoolTripMutation = () => {
  const { data: currentEventData } = useCurrentEventQuery();
  const { showToast } = useToast();
  const [mutate] = useMutation<
    StaffLeaveCarpoolTripMutation,
    StaffLeaveCarpoolTripMutationVariables
  >(STAFF_LEAVE_CARPOOL_TRIP);

  const staffLeaveCarpoolTrip = async (tripId: string, userId: string) => {
    const eventId = currentEventData?.currentEvent?.id;
    if (!eventId) {
      return;
    }

    await mutate({
      variables: { tripId, userId },
      refetchQueries: [
        {
          query: CARPOOL_TRIPS,
          variables: { eventId } satisfies CarpoolTripsQueryVariables,
        },
      ],
    });

    showToast({
      type: 'success',
      message: 'Passager retiré.',
    });
  };

  return { staffLeaveCarpoolTrip };
};
